import { initAnalytics } from './index';

export function initPostHog(): void {
  // Fire-and-forget; provider is async but getAnalytics() falls back to Noop
  // until the real provider resolves.
  initAnalytics().catch((e) => {
    console.warn('[analytics] init failed', e);
  });
}
